import { useState } from "react";
import { toast } from "sonner";
import { adminAssignArtist } from "@/lib/afmApi";
import AdminArtistSearch from "@/components/AdminArtistSearch";

// Super admin: pasa un lanzamiento del sello a la cuenta del artista cuando ya la tiene.
export default function AssignToArtist({ releaseId, onDone }) {
  const [pick, setPick] = useState(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await adminAssignArtist(releaseId, pick.id);
      toast.success(`Asignado a ${pick.stage_name || pick.name}`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo asignar");
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-lg border border-slate-200 p-3" data-testid="assign-to-artist">
      <p className="mb-2 text-xs font-semibold text-black">Asignar a la cuenta del artista</p>
      {pick ? (
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="font-semibold text-black">{pick.stage_name || pick.name}</span>
          <span className="text-xs text-slate-500">{pick.email}</span>
          <button type="button" onClick={() => setPick(null)} className="text-xs font-semibold text-slate-600 underline">Cambiar</button>
          <button type="button" data-testid="assign-to-artist-save" disabled={busy || !pick.has_plan} title={pick.has_plan ? "" : "Aún no tiene plan activo"} onClick={save} className="ml-auto rounded-lg bg-black px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-50">{busy ? "Asignando…" : "Asignar"}</button>
        </div>
      ) : <AdminArtistSearch onPick={setPick} />}
    </div>
  );
}
